import React, { useState, useEffect, useCallback } from "react";
import { Form, Menu, Icon, Button, Loader, Segment } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 as api } from "../../../../services/apis";
import swal from "sweetalert";
import "../../../../assets/css/guia_pages.css";
import * as yup from "yup";
import { toast } from "react-toastify";

import Curso from "../../../../components/Admin/AlunosUpdate/Curso";
import Back from "../../../../components/Admin/AlunosUpdate/Back";
import Privileges from "../../../../components/Admin/AlunosUpdate/Privileges";
import { withRouter } from "react-router-dom";

import {
  SemanticTable,
  Content,
  Container,
  Title,
  Input,
  Field,
  InlineField,
  Select,
  Label,
  Textarea,
  Image,
  Link,
} from "./styles";

import { isAuthAdmin } from "../../../../services/auth";
import Pedido from "../../../../components/Admin/AlunosUpdate/Pedido";
import AlunosSelector from "../../../../components/Admin/AlunosSelector";
import { datePattern, formatValue } from "../../../../utils/Utils";
import { BiLinkExternal } from "react-icons/bi";
import MBA from "../../../../components/Admin/AlunosUpdate/MBA";
import { useRouter } from "../../../../hooks/router";

const sortCursosByValidity = (direction = 'ascending') => (courseA, courseB) => {
  if(new Date(courseA?.validadeData?.validateOption?.time) > new Date(courseB?.validadeData?.validateOption?.time)) return direction === 'ascending' ? 1 : -1;
  if(new Date(courseA?.validadeData?.validateOption?.time) < new Date(courseB?.validadeData?.validateOption?.time)) return direction === 'ascending' ? -1 : 1;

  if(courseA?.validade === 180 && courseB?.validade !== 180) return 1;
  if(courseA?.validade !== 180 && courseB?.validade === 180) return -1;
}

function AlunosUpdate(props) {
  const [aluno, setAluno] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [valorName, setValorName] = useState("dados");
  const [admin, setAdmin] = useState(false);
  const [permissoes, setPermissoes] = useState("");
  const [observacao, setObservacao] = useState("");
  const [isUserPassword, setIsUserPassword] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const [giftUserId, setGiftUserId] = useState(null);
  const [giftCoins, setGiftCoins] = useState(0);
  const [havePagarmeSignature, setHavePagarmeSignature] = useState(false);
  const [signatures, setSignatures] = useState([]);
  const [page, setPage] = useState(1);
  const [validitySort, setValiditySort] = useState("ascending");

  const router = useRouter();

  const idAluno = props.match.params.id;

  useEffect(() => {
    loadAuth();

    api
      .get(`admin/eadalunos/${idAluno}`)
      .then(async res => {
        const { aluno } = res.data;

        let logs = {
          local: "alunos/editar",
          texto: `listou o aluno de id=${idAluno}`,
        };
        api.post("system_logs", { acao: JSON.stringify(logs) });

        const voitto_coins = { voittocoins: 0 };

        if (!aluno.voitto_coins) {
          aluno.voitto_coins = voitto_coins;
        }

        if (aluno.rec_senha && aluno.rec_senha !== "0") {
          console.log("ALUNO REC_ SENHA", aluno.rec_senha);
          setIsUserPassword(false);
        }

        setAluno(aluno);
        setAdmin(true);
        setLoading(false);
      })
      .catch(err => {
        console.log("ERRO ALUNO INVÁLIDO", err);

        swal(
          "Aluno invalido",
          "Ops! Parece que esse aluno não existe.",
          "error"
        );
        setLoading(false);
      });

    getObservacao();
    getSignatures();
  }, []);

  useEffect(() => {
    api
      .get(`/admin/pessoa/${idAluno}/pedidos`)
      .then(async res => {
        const pedidos = res.data;

        setPedidos([...pedidos]);
      })
      .catch(err => {
        console.log("ERRO ALUNO INVÁLIDO", err);

        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const { hash } = props.location;

    const tab = ["dados", "cursos", "observacao", "assinaturas"].find(
      tab => tab === hash.toLowerCase().replace("#", "")
    );

    if (!tab) {
      return;
    }

    setValorName(tab);
  }, [props]);

  useEffect(() => {
    if(router.query.step){
      setValorName(router.query.step);
    }
  },[]);

  const getSignatures = useCallback(() => {
    api
      .get("/pagarme/assinantes", {
        params: { page, total_items: 10, ref: idAluno },
      })
      .then(res => {
        setHavePagarmeSignature(res.data.itens.length > 0);
        setSignatures(res.data.itens);
      })
      .catch(err => console.log(err));
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const getObservacao = useCallback(() => {
    api
      .get(`pessoas/${idAluno}/observacao`)
      .then(res => {
        setObservacao(res.data.obs);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  const sendObservacao = useCallback(() => {
    api
      .post(`pessoas/${idAluno}/observacao`, { obs: observacao })
      .then(res => {
        swal("Sucesso !", "Observação alterada.", "success");
      })
      .catch(err => {
        console.error(err);
      });
  }, [observacao]);

  const handleItemClick = (e, { name }) => {
    setValorName(name);
  };

  const ValorStatus = () => {
    if (aluno.verificado === true) {
      return "verificado!";
    }

    return "não verificado!";
  };

  const handleAdmin = adminValue => {
    setAdmin(adminValue);
  };

  const handlePermissoes = permissoesJson => {
    const newPermissoes = Object.keys(permissoesJson)
      .filter(key => permissoesJson[key])
      .join(", ");
    setPermissoes(newPermissoes);
  };

  const uploadImage = async file => {
    if (!file) {
      return;
    }

    try {
      const inputData = new FormData();

      inputData.append("file", file);
      inputData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

      const UploadReq = await api.post("/upload", inputData);
      setAluno({ ...aluno, foto: UploadReq.data.url });

      toast.success("A imagem foi enviada com sucesso!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const update = useCallback(async () => {
    const AlunoValidation = yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome do aluno")
        .required("Necessário que informe o nome do aluno"),
      email: yup
        .string("Necessário que informe a email do aluno")
        .required("Necessário que informe a email do aluno"),
      celular: yup.string("Necessário que informe a celular do aluno"),
      data_nascimento: yup.string(
        "Necessário que informe a data de nascimento do aluno"
      ),
    });

    try {
      const alunoPayload = await AlunoValidation.validate(aluno, {
        abortEarly: true,
      });

      delete alunoPayload.pessoa_cursos;

      const payload = {
        aluno: alunoPayload,
        permissao: permissoes,
        isAdmin: admin,
      };

      api
        .put(`/admin/eadalunos/${idAluno}`, payload)
        .then(() => {
          toast.success("A operação foi concluida com sucesso!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        })
        .catch(err => {
          swal("Não foi possível salvar o Aluno", err, "error");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  }, [admin, aluno, permissoes]);

  const changePassword = useCallback(async () => {
    const payload = {
      aluno: {
        senha: aluno.id,
      },
      permissao: permissoes,
      isAdmin: admin,
    };

    setAluno(aluno => ({ ...aluno, senha: aluno.id }));

    api
      .put(`/admin/eadalunos/${idAluno}/password-toggle`, payload)
      .then(() => {
        setIsUserPassword(isUserPassword => !isUserPassword);

        toast.success("A operação foi concluida com sucesso!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch(err => {
        swal("Não foi possível trocar a senha do aluno", err, "error");
      });
  }, [admin, aluno, permissoes]);

  const handleUploadImage = file => {
    uploadImage(file).then(() => setSelectedFile(""));
  };

  const unlock = async () => {
    api
      .post(`/admin/pedidos-tentativa/unblock/${idAluno}`)
      .then(res => {
        if (res.data) {
          toast.success("A operação foi concluida com sucesso!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return;
        }

        toast.error("A operação foi concluida sem sucesso!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch(err => {
        toast.success(`Um erro ocorreu internamente: ${err} , acione o TI!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const unlockInscricao = async () => {
    api
      .post(
        `admin/pessoa/confirmacao`,
        {
          id_pessoa: idAluno,
        },
        {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        }
      )
      .then(() => {
        toast.success("A operação foi concluida com sucesso!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch(err => {
        toast.success(`Um erro ocorreu internamente: ${err} , acione o TI!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const deleteUser = async () => {
    api
      .delete(
        `admin/deletausuario/${idAluno}`,
        {
          id_pessoa: idAluno,
        },
        {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        }
      )
      .then(() => {
        toast.success("A operação foi concluida com sucesso!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch(err => {
        toast.success(`Um erro ocorreu internamente: ${err} , acione o TI!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const deleteCurso = useCallback(
    (id_curso, id_pessoa) => {
      const newAluno = { ...aluno };
      const pessoa_cursos = [...newAluno.pessoa_cursos];

      newAluno.pessoa_cursos = pessoa_cursos.filter(
        pco => pco.id_curso !== id_curso
      );

      swal(
        "Importante!",
        "Você tem certeza que quer excluir este relacionamento ?",
        ""
      ).then(res => {
        if (res) {
          api
            .delete(`admin/eadalunos/${id_pessoa}/curso/${id_curso}`)
            .then(res => {
              setAluno(newAluno);
              swal("Sucesso!", "O relacionamento foi excluído com sucesso.", "success");
              window.location.reload();
              
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    [aluno]
  );

  const deleteMBA = useCallback(
    async (id_mba) => {
      const newAluno = { ...aluno };
      const pessoa_mbas = [...newAluno.pessoa_mbas];

      newAluno.pessoa_mbas = pessoa_mbas.filter(
        mba => mba.id_combo !== id_mba
      );

      swal(
        "Importante!",
        "Você tem certeza que quer remover este MBA ?",
        ""
      ).then(async res => {
        if (res) {
          try {
            api
              .delete(`/admin/mba/remove-live/${idAluno}/${id_mba}`)
              .then(async () => {
                swal("MBA removido", "", "success").then(() => {location.reload()});

                setAluno(newAluno);
              });
          } catch (error) {
            swal("Houve um erro ao liberar o MBA", "", "error").then(async () =>
              {location.reload()}
            );

            const logs = {
              local: "/admin/mba/remover",
              texto: `Tentou remover o MBA (${id_mba}) do aluno (${idAluno}) - Erro: ${error}`,
            };

            await api.post("system_logs", {
              acao: JSON.stringify(logs),
            });
          }
        }
      });
    },
    [aluno]
  );

  const Dados = useCallback(() => {
    return (
      <>
        <Field>
          <h2>Dados Basicos</h2>

          <Field>
            <Label>Nome (Para certificado)</Label>
            <Input
              type="text"
              value={aluno.nome}
              onChange={e => setAluno({ ...aluno, nome: e.target.value })}
            />
          </Field>

          <Field>
            <Label>E-mail</Label>
            <Input
              type="text"
              value={aluno.email}
              onChange={e => setAluno({ ...aluno, email: e.target.value })}
            />
          </Field>
          <Field>
            <Button type="button" onClick={changePassword}>
              {isUserPassword
                ? "Tornar senha padrão"
                : "Retornar senha do usuário"}
            </Button>
            <Button title="Redireciona para a página Inserção de VoittoCoins" type="button"  onClick={() => window.open("/admin/alunos/voittocoins", "_blank")}>
              Inserir VoittoCoins
            </Button>
            <Button
              title="Redireciona para a página de bloqueio do usuário"
              as="a"
              target="_blank"
              href={`/admin/bloqueio-acesso?id_pessoa=${aluno?.id}`}
            >
              Bloquear usuário
            </Button>

          </Field>
          <Field>
            <Label>Celular / WhatsApp</Label>
            <Input
              type="text"
              value={aluno.celular}
              onChange={e => setAluno({ ...aluno, celular: e.target.value })}
            />
          </Field>
          <Field>
          </Field>
          {/* <Field>
            <h3>Foto:</h3>
            <Image src={aluno.foto} />
            <Input
              type="file"
              onChange={e => setSelectedFile(e.target.files[0])}
              style={{ height: "min-content" }}
            />
            {selectedFile ? (
              <img
                style={{
                  marginTop: "1rem",
                  maxWidth: "240px",
                  maxHeight: "240px",
                }}
                src={URL.createObjectURL(selectedFile)}
              />
            ) : null}
            <Field>
              <Button
                type="submit"
                onClick={() => handleUploadImage(selectedFile)}
              >
                <Icon name="save" />
                Enviar foto
              </Button>
            </Field>
          </Field> */}
          <Field>
            <Label>Data de Nascimento</Label>
            <Input
              type="text"
              value={aluno.data_nascimento}
              onChange={e =>
                setAluno({ ...aluno, data_nascimento: e.target.value })
              }
            />
          </Field>
          <Field>
            <Label>CPF</Label>
            <Input
              type="text"
              value={aluno.cpf}
              onChange={e => setAluno({ ...aluno, cpf: e.target.value })}
            />
          </Field>
          <InlineField>
            <Field>
              <Label>CEP</Label>
              <Input
                type="text"
                value={aluno.cep}
                onChange={e => setAluno({ ...aluno, cep: e.target.value })}
              />
            </Field>
            <Field>
              <Label>Endereço</Label>
              <Input
                type="text"
                value={aluno.endereco}
                onChange={e => setAluno({ ...aluno, endereco: e.target.value })}
              />
            </Field>
            <Field>
              <Label>Número</Label>
              <Input
                type="text"
                value={aluno.numero}
                onChange={e => setAluno({ ...aluno, numero: e.target.value })}
              />
            </Field>
          </InlineField>
          <Field>
            <Label>Bairro</Label>
            <Input
              type="text"
              value={aluno.bairro}
              onChange={e => setAluno({ ...aluno, bairro: e.target.value })}
            />
          </Field>
          <Field>
            <Label>Complemento</Label>
            <Input
              type="text"
              value={aluno.complemento}
              onChange={e =>
                setAluno({ ...aluno, complemento: e.target.value })
              }
            />
          </Field>
          <InlineField>
            <Field>
              <Label>Cidade</Label>
              <Input
                type="text"
                value={aluno.cidade}
                onChange={e => setAluno({ ...aluno, cidade: e.target.value })}
              />
            </Field>
            <Field>
              <Label>Estado</Label>
              <Select
                value={aluno.estado}
                onChange={e => setAluno({ ...aluno, estado: e.target.value })}
              >
                <option value="">Seu Estado</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP" selected="">
                  São Paulo
                </option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </Select>
            </Field>
          </InlineField>
          {/* <Field>
            <Label>Ocupação</Label>
            <Select
              value={aluno.ocupacao}
              onChange={e => setAluno({ ...aluno, ocupacao: e.target.value })}
            >
              <option value="0">Estudante</option>
              <option value="1">Profissional</option>
            </Select>
          </Field> */}

          {/* <InlineField margin={"0 0 10px 0"}>
            <Field>
              <Label>Empresa</Label>
              <Input
                type="text"
                value={aluno.ocupacaoLocal}
                onChange={e =>
                  setAluno({ ...aluno, ocupacaoLocal: e.target.value })
                }
              />
            </Field>
            <Field>
              <Label>Cargo</Label>
              <Input
                type="text"
                value={aluno.ocupacaoInfo}
                onChange={e =>
                  setAluno({ ...aluno, ocupacaoInfo: e.target.value })
                }
              />
            </Field>
          </InlineField> */}

          <div>
            {/* <Privileges
              handlePermissoes={handlePermissoes}
              permissoes={aluno.permissoes}
              handleAdmin={handleAdmin}
              aluno={aluno}
            /> */}
          </div>

          <Field>
            <Button type="submit" onClick={() => update()}>
              <Icon name="save" />
              Salvar
            </Button>
          </Field>
        </Field>
      </>
    );
  }, [aluno, isUserPassword, selectedFile]);

  const Cursos = useCallback(() => {
    return (
      <div style={{maxWidth: "100%", overflow:"auto"}}>
      <Field>
        <h2>Cursos</h2>
        <Field>
          <SemanticTable size="small" celled sortable>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Data Inicio</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Último Acesso
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Andamento</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell
                  sorted={validitySort}
                  onClick={() => setValiditySort(prev => prev === 'ascending' ? 'descending' : 'ascending')}
                >
                  Validade
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Analisar Validade
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Certificado</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
                {/* <SemanticTable.HeaderCell>
                  Faz parte do premium 1 Ano ?
                </SemanticTable.HeaderCell> */}
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {(aluno?.pessoa_cursos || [])
                .filter(curso => curso && curso.curso)
                .sort(sortCursosByValidity(validitySort))
                .map(curso => {
                  return (
                    <Curso
                      curso={curso}
                      delete={() => deleteCurso(curso.id_curso, curso.id_pessoa)}
                    />
                  )
                })}
            </SemanticTable.Body>
          </SemanticTable>
        </Field>
      </Field>
      </div>
    );
  }, [aluno, validitySort]);
  
  const MBAs = useCallback(() => {
    return (
      <div style={{maxWidth: "100%", overflow:"auto"}}>
      <Field>
        <h2>MBAs</h2>
        <Field>
          <SemanticTable size="small" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>MBA</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {(aluno?.pessoa_mbas || [])
                .filter(mba => mba && mba.curso)
                .map(mba => (
                  <MBA
                    mba={mba}
                    delete={() => deleteMBA(mba.id_curso)}
                  />
                ))}
            </SemanticTable.Body>
          </SemanticTable>
        </Field>
      </Field>
      </div>
    );
  }, [aluno]);

  const Observacao = useCallback(() => {
    return (
      <Field>
        <h2>Observação</h2>
        <Field>
          <Textarea
            value={observacao}
            onChange={e => setObservacao(e.target.value)}
          ></Textarea>
        </Field>
        <Field>
          <Button type="submit" onClick={sendObservacao}>
            <Icon name="save" />
            Salvar Observação
          </Button>
        </Field>
      </Field>
    );
  }, [observacao]);

  const Pedidos = useCallback(() => {
    return (
      <Field>
        <h2>Pedidos</h2>
        <Field>
          <SemanticTable size="small" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  ID Inscrição
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>ID Pedido</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Data</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Validade</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Cupom</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Forma de pagamento
                </SemanticTable.HeaderCell>
                {/* <SemanticTable.HeaderCell>Link Pagamento Voitto</SemanticTable.HeaderCell> */}
                <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Investimento
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {pedidos.map(pedido => (
                <Pedido pedido={pedido} />
              ))}
            </SemanticTable.Body>
          </SemanticTable>
        </Field>
      </Field>
    );
  }, [pedidos]);

  const submitTransferCoins = async () => {
    const data = {
      ownerId: aluno.id,
      giftUserId: giftUserId,
      valueCoins: +giftCoins,
    };
    const erros = [];

    Object.entries(data).forEach(([key, value]) => {
      const fieldsNames = {
        ownerId: "Aluno",
        giftUserId: "Aluno q vai receber os voitto coins",
        valueCoins: "Quantidade de voitto coins",
      };

      if (!value) {
        erros.push(fieldsNames[key]);
      }
    });

    if (erros.length > 0) {
      swal({
        title: "Erro",
        text: `Preencha os campos: \n${erros.join("\n")}`,
        icon: "error",
      });
      return;
    }

    await api
      .post("/admin/voittocoins/transfer", data)
      .then(res => {
        console.log(res.data);
        swal({
          title: "Sucesso",
          text: res.data.message,
          icon: "success",
        }).then(() => window.location.reload());
      })
      .catch(err => {
        swal({
          title: "Erro",
          text: err.response.data?.message || "Erro ao transferir voitto coins",
          icon: "error",
        });
      });
  };

  const transferenciaVoittoCoins = () => {
    return (
      <div>
        <h2>Transferência de Voitto Coins</h2>
        <h4>
          Saldo atual:{" "}
          {aluno?.voitto_coins?.voittocoins >= 0
            ? aluno?.voitto_coins?.voittocoins
            : aluno?.voitto_coins}
        </h4>
        <Field>
          <strong>Aluno q vai receber os voitto coins:</strong>
          <AlunosSelector handleChange={setGiftUserId} />
        </Field>
        <Field>
          <Input
            type="number"
            value={giftCoins}
            min={0}
            max={
              aluno?.voitto_coins?.voittocoins >= 0
                ? aluno?.voitto_coins?.voittocoins
                : aluno?.voitto_coins
            }
            onChange={e => setGiftCoins(e.target.value)}
          />
        </Field>
        <Field>
          <Button onClick={submitTransferCoins}>
            <Icon name="sync" />
            Transferir
          </Button>
        </Field>
      </div>
    );
  };

  const statusMap = {
    active: <p className="status active">Ativo</p>,
    canceled: <p className="status canceled">Cancelado</p>,
  };

  const statusDisplay = status => {
    return statusMap[status] || <p className="status">{status}</p>;
  };

  const Assinaturas = useCallback(() => {
    return (
      <Field>
        <h2>Informações da assinatura</h2>
        <Field>
          <SemanticTable stackable>
            <SemanticTable.Header>
              <SemanticTable.HeaderCell>
                <p>Id pedido</p>
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                <p>Produto</p>
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                <p>Data da assinatura</p>
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                <p>Parcelas</p>
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                <p>Próxima cobrança</p>
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                <p>Status</p>
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                <p>Ver detalhes</p>
              </SemanticTable.HeaderCell>
            </SemanticTable.Header>
            {signatures.map((signature, index) => (
              <SemanticTable.Row key={index}>
                <SemanticTable.Cell>
                  <p>{signature.id_pedido}</p>
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <p>{signature.fature.items[0].name}</p>
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <p>{datePattern(signature.created_at)} </p>
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <p>{signature.cycle}</p>
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <p>{datePattern(signature.nextBilling)}</p>
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {statusDisplay(signature.status)}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <Link
                    href={`/admin/pagarme/assinante/${idAluno}?id_assinatura=${signature.subscribe}`}
                    target="_blank"
                  >
                    <BiLinkExternal /> Acessar
                  </Link>
                </SemanticTable.Cell>
              </SemanticTable.Row>
            ))}
          </SemanticTable>
        </Field>
      </Field>
    );
  }, [signatures]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <div
          style={{
            width: "100%",
            height: "max-content",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <Back />
        </div>

        {loading ? (
          <Loader
            style={{ marginTop: "auto", marginBottom: "auto" }}
            active
            inline="centered"
            size="massive"
          />
        ) : (
          <Content>
            <Title>{aluno?.nome || "Aluno"}</Title>
            <Form>
              <div>
                <Menu pointing>
                  <Menu.Item
                    name="dados"
                    active={valorName === "dados"}
                    onClick={handleItemClick}
                  >
                    Dados
                  </Menu.Item>
                  <Menu.Item
                    name="cursos"
                    active={valorName === "cursos"}
                    onClick={handleItemClick}
                  >
                    Cursos
                  </Menu.Item>
                  <Menu.Item
                    name="mbas"
                    active={valorName === "mbas"}
                    onClick={handleItemClick}
                  >
                    MBAs
                  </Menu.Item>
                  <Menu.Item
                    name="pedidos"
                    active={valorName === "pedidos"}
                    onClick={handleItemClick}
                  >
                    Pedidos
                  </Menu.Item>
                  {havePagarmeSignature && (
                    <Menu.Item
                      name="assinatura"
                      active={valorName === "assinatura"}
                      onClick={handleItemClick}
                    >
                      <span>Assinaturas</span>
                    </Menu.Item>
                  )}
                  <Menu.Item
                    name="observacao"
                    active={valorName === "observacao"}
                    onClick={handleItemClick}
                  >
                    <span style={{ color: observacao && "red" }}>
                      Observação
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    name="transferencia"
                    active={valorName === "transferencia"}
                    onClick={handleItemClick}
                  >
                    <span>Transferência de voittocoins</span>
                  </Menu.Item>

                  <Menu.Menu position="right">
                    <h3
                      style={{
                        position: "relative",
                        top: "15px",
                        right: "15px",
                      }}
                    >
                      ID:{aluno.id}
                    </h3>
                  </Menu.Menu>
                </Menu>

                <Segment>
                  <div>
                    {
                      {
                        dados: Dados(),
                        cursos: Cursos(),
                        mbas: MBAs(),
                        observacao: Observacao(),
                        pedidos: Pedidos(),
                        transferencia: transferenciaVoittoCoins(),
                        assinatura: Assinaturas(),
                      }[valorName]
                    }
                  </div>
                </Segment>
                {/* <Field>
                  <Label>
                    {" "}
                    <h3>Status:</h3>
                    {ValorStatus()}
                  </Label>
                </Field> */}
                {/* <Field>
                  <Button
                    type="submit"
                    onClick={() =>
                      setAluno({ ...aluno, verificado: !aluno.verificado })
                    }
                  >
                    <Icon name="check" />
                    Verificar senha do aluno
                  </Button>
                </Field> */}
                {/* <Field>
                  <Label>
                    <h3>Desbloqueio de alunos:</h3>
                  </Label>
                </Field> */}
                {/* <Field>
                  <Button onClick={() => unlock()}>
                    <Icon name="lock" />
                    Desbloquear aluno
                  </Button>
                </Field> */}
                {/* <Field>
                  <Button onClick={() => unlockInscricao()}>
                    <Icon name="lock" />
                    Desbloquear aluno no inscrição
                  </Button>
                </Field> */}
                {/* <Field>
                  <Label>
                    <h3>Excluir conta:</h3>
                  </Label>
                </Field> */}
                {/* <Field>
                  <Button onClick={() => deleteUser()}>
                    <Icon name="lock" />
                    Excluir conta
                  </Button>
                </Field> */}
              </div>
            </Form>
          </Content>
        )}
      </Container>
    </div>
  );
}
export default withRouter(AlunosUpdate);
